import React, { useState, useRef } from 'react';
import { format, getDay, parse } from 'date-fns'
import PropTypes from 'prop-types';

import { weatherIconMap } from '../../../../helpers/constants';

const WeatherReportItem = ({
  item,
  labelPastSnowball,
  labelTodaySnowball,
  labelTonightsSnowball,
  labelWindSpeed,
  unavailableDataPointMessage
}) => {
  const [expanded, setExpanded] = useState(false);
  const infoContainerRef = useRef(null);
  const days = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ];
  const date = format(new Date(item.date.replace(/-/g, '/')), 'MMM-d-yyyy');
  const dateArray = date.split('-');
  const day = days[getDay(new Date(item.date.replace(/-/g, '/')))];

  const handleExpand = () => {

    if (!expanded) {
      setExpanded(true);
      infoContainerRef.current.ariaExpanded = 'true';
    } else {
      setExpanded(false);
      infoContainerRef.current.removeAttribute('aria-expanded');
    }
  };
  return (
    <div
      className="weather-report-update__accordion"
      onClick={() => {
        handleExpand();
      }}
      ref={infoContainerRef}
    >
      <div className="weather-report-update__accordion-container">
        <div className="weather-report-update__accordion-info-container">
          <div className="weather-report-update__accordion-date">
            <span>{dateArray[0]}</span>
            <span className="bold">{dateArray[1]}</span>
          </div>
          <div className="weather-report-update__accordion-day">{day}</div>
          <div className="weather-report-update__accordion-icon">
            <svg>
              <title>weather</title>
              <use xlinkHref={`#${weatherIconMap[item.icon]}`} />
            </svg>
          </div>
          <div className="weather-report-update__accordion-temp bold">
            <svg viewBox="0 0 11 16">
              <use xlinkHref="#arrow-up" />
            </svg>
            {item.maxTempFahrenheit}°F
          </div>
          <div className="weather-report-update__accordion-temp bold">
            <svg viewBox="0 0 11 16">
              <use xlinkHref="#arrow-down" />
            </svg>
            {item.minTempFahrenheit}°F
          </div>
        </div>
        <div
          className="weather-report-update__icon-container"
        >
          <span className="weather-report-update__icon-minus">
            <svg viewBox="0 0 11 16">
              <title>decrease</title>
              <use xlinkHref="#minus" />
            </svg>
          </span>
          <span className="weather-report-update__icon-plus">
            <svg viewBox="0 0 11 16">
              <title>add</title>
              <use xlinkHref="#plus" />
            </svg>
          </span>
        </div>
      </div>
      <div className='weather-report-update__main-container'>
        <div className='weather-report-update__container'>
          <div className='weather-report-update__main-block'>
            <div className='weather-report-update__summary-icon'>
              <svg>
                <title>summary</title>
                <use xlinkHref={`#${weatherIconMap[item.icon]}`} />
              </svg>
            </div>
            <div className='weather-report-update__todays-grid'>
              <div className='weather-report-update__todays-block'>
                <span className='weather-report-update__font-light'>{item.condition}</span>
                <span className='weather-report-update__font-bold'>{item.tempFahrenheit}°F</span>
              </div>
              <div className='weather-report-update__todays-block'>
                <span className='weather-report-update__font-light'>{item.tempCelsius}°C</span>
              </div>
              <div className='weather-report-update__todays-block'>
                <span className='weather-report-update__font-bold small'>
                  <svg viewBox="0 0 11 16">
                    <use xlinkHref="#arrow-up" />
                  </svg>
                  {item.maxTempFahrenheit}°F
                </span>
              </div>
              <div className='weather-report-update__todays-block'>
                <span className='weather-report-update__font-bold small'>
                  <svg viewBox="0 0 11 16">
                    <use xlinkHref="#arrow-down" />
                  </svg>
                  {item.minTempFahrenheit}°F
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='weather-report-update__secondary-block'>
          <div className='weather-report-update__summary-block'>
            <span className='weather-report-update__summary-bold'>{item.past24HrSnow}&quot;</span>
            <span className='weather-report-update__summary-light'>{labelPastSnowball}</span>
          </div>
          <div className='weather-report-update__summary-block'>
            <span className='weather-report-update__summary-bold'>{item.todaySnow}&quot;</span>
            <span className='weather-report-update__summary-light'>{labelTodaySnowball}</span>
          </div>
          <div className='weather-report-update__summary-block'>
            <span className='weather-report-update__summary-bold'>{item.tonightSnow}&quot;</span>
            <span className='weather-report-update__summary-light'>{labelTonightsSnowball}</span>
          </div>
          <div className='weather-report-update__summary-block'>
            <span><b className='weather-report-update__summary-bold'>{item.windSpeed}mph</b> {item.windDirection}</span>
            <span className='weather-report-update__summary-light'>{labelWindSpeed}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

WeatherReportItem.propTypes = {
  labelPastSnowball: PropTypes.string.isRequired,
  labelTodaySnowball: PropTypes.string.isRequired,
  labelTonightsSnowball: PropTypes.string.isRequired,
  labelWindSpeed: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  unavailableDataPointMessage: PropTypes.string.isRequired
};

export default WeatherReportItem;
